import React from "react";
import { FormLayout, FormSection } from "playground/cms/Form";
import Form from "containers/Form";
import Field from "containers/Field";
import { Property, PropertyGrid } from "playground/cms/fields/Properties";
import { MediaField } from "playground/cms/fields/Media";
import { useData } from "state/hooks";
import TagsField from "playground/cms/fields/TagsField";
import { useSelector } from "react-redux";
import { selectIsDraft } from "state/selectors/data";

//import PropTypes from 'prop-types';

export function FlatsForm(props) {
    const { type, id } = props;
    const { name, code_part, levels } = useData(props);
    const isDraft = useSelector((store) => selectIsDraft(store, type, id));
    const label = name + " (" + code_part + ")";
    return (
        <FormLayout.Fieldset pad>
            <div className={"rows gap-md"}>
                <FormSection name={label} collapsed={!isDraft}>
                    <FormLayout.Fieldset>
                        <div className={"cols cols-2 gap-sm"}>
                            <Field id={"name"} label={"Nazwa"} />
                            <Field id={"code_part"} label={"Kod"} />
                            <Field
                                id={"type"}
                                fieldType={"select"}
                                label={"Typ"}
                                source={"schema:data.flat-type"}
                            />
                        </div>
                        <Field
                            id={"floor"}
                            fieldType={"select"}
                            label={"Budynek / piętro"}
                            source={"api:floors"}
                        />
                    </FormLayout.Fieldset>
                </FormSection>

                <div className={"cols cols-2 gap-sm"}>
                    <Field
                        id={"status"}
                        fieldType={"select"}
                        label={"Dostępność"}
                        source={"schema:data.flat-status"}
                    />
                    <Field
                        id={"development_stage"}
                        fieldType={"select"}
                        label={"Etap budowy"}
                        source={"schema:data.development-stage"}
                    />
                </div>

                <PropertyGrid>
                    <Property label={"Cena / m2"}>
                        <Field
                            id={"price"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Cena całk."}>
                        <Field
                            id={"flat_price"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Czynsz"}>
                        <Field
                            id={"rent_amount"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Zwrot %"}>
                        <Field
                            id={"gain_factor"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Pow. użytk."}>
                        <Field
                            id={"flat_area"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Pow. działki"}>
                        <Field
                            id={"plot_area"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                </PropertyGrid>
                <Field
                    id={"tags"}
                    label={"Tagi"}
                    fieldType={"select"}
                    source={"api:tags"}
                    multiple={true}
                    taggable={true}
                    nullable={true}
                />
                <MediaField id={"media"} label={"Załączniki"} />
                <Field id={"text"} fieldType={"rich"} />
                <pre>{JSON.stringify(levels, null, 2)}</pre>
                {/*<Form type={type} id={id} />*/}
            </div>
        </FormLayout.Fieldset>
    );
}

FlatsForm.propTypes = {};

FlatsForm.defaultProps = {};

export default FlatsForm;
